<ng-container *ngIf="dateCreationMenu">

  <ng-container *ngIf="dateSaisieEffectif">

    <div class="day-cell saisie-effectifs-day" pTooltip="Menus validés"
         showDelay="500">{{date.day}}</div>

  </ng-container>

  <ng-container *ngIf="!dateSaisieEffectif">
    <div class="creation-menus-day" pTooltip="Menus en cours de saisie" showDelay="500">{{date.day}}</div>
  </ng-container>
</ng-container>


<ng-container *ngIf="!dateCreationMenu">

  <ng-container *ngIf="dateSaisieEffectif">

    <div class="day-cell saisie-effectifs-day" pTooltip="Menus validés"
         showDelay="500">{{date.day}}</div>

  </ng-container>

  <ng-container *ngIf="!dateSaisieEffectif">
  <div pTooltip="Aucun menu" showDelay="500">{{date.day}}</div>
  </ng-container>

</ng-container>
